import { render, staticRenderFns } from "./select-matricula.vue?vue&type=template&id=b86cbf62&"
import script from "./select-matricula.vue?vue&type=script&lang=js&"
export * from "./select-matricula.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports